import { Box, BoxProps } from '@amzn/ring-ui-react-components';

export type CardBodyProps = Omit<BoxProps, 'flex'>;

export const CardBody = (props: CardBodyProps) => (
  <Box p={3} {...props} tabIndex={0} flex={1} />
);
